import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {shopCertificate} from '../../../contants';
import {RootState} from '../../../../../../store/redux';
import {addAddress} from '../../../../../../store/redux/myStoreSelectedLocation';
import {get_times_hours} from '../../../../advertisementRegisteration/constants';
import useGetStoreTypeList from '../../../../../../services/hookService/getStoreTypeList/useGetStoreTypeList';
import {
  addCertificateLists,
  addOptionalRegisterStoreFormData,
  addRegisterStoreFormData,
} from '../../../../../../store/redux/registerStore';

const useCreateObjEditLab = (labDetail?: IGetLabDetail) => {
  const dispatch = useDispatch();

  const {data} = useGetStoreTypeList({});
  const selected_input = data?.find(item => item.id === 2);

  const stateRedux = useSelector((state: RootState) => state.registerStore);

  useEffect(() => {
    if (labDetail && !stateRedux.recall && !stateRedux.optionalIsOpen) {
      const {
        title,
        about,
        state_info,
        city_info,
        location,
        from_hour,
        to_hour,
        land_line,
        in_person_possibility,
        has_delivery,
        has_guarantee,
        address,
        lab_field,
        result_to_day,
        speciality,
        certificate,
        logo,
        license,
        lab_photo,
      } = labDetail;

      const formData = {
        selectedInput: selected_input
          ? {
              id: selected_input.id,
              code: selected_input.code,
              guid: selected_input.guid,
            }
          : undefined,
        title: title ? title : undefined,
        about: about ? about : undefined,
        in_person_possibility: in_person_possibility
          ? in_person_possibility
          : undefined,
        has_delivery: has_delivery ? has_delivery : undefined,
        has_guarantee: has_guarantee ? has_guarantee : undefined,
        address: address ? address : undefined,
        land_line: land_line ? land_line : undefined,
        lab_fields: lab_field ? lab_field?.map(item => item.code) : undefined,
        logo: {file: null, logo: logo},
        license: {file: null, license: license},
        lab_photo: {file: null, lab_photo: lab_photo},
      };

      const certificateArr = certificate
        ? certificate.map((id: string) =>
            shopCertificate.find(cert => cert.code === id),
          )
        : undefined;

      const optionalFormData = {
        to_hour: to_hour ? get_times_hours(to_hour) : undefined,
        from_hour: from_hour ? get_times_hours(from_hour) : undefined,
        result_to_day: result_to_day ? result_to_day : undefined,
        speciality: speciality ? speciality : undefined,
      };

      dispatch(addRegisterStoreFormData({...stateRedux, ...formData}));

      //@ts-ignore
      dispatch(addCertificateLists(certificateArr));
      dispatch(
        addOptionalRegisterStoreFormData(JSON.stringify(optionalFormData)),
      );
      dispatch(
        addAddress({
          id: Number(city_info?.id),
          name: `${state_info?.name},${city_info?.name}`,
          location: location,
          state_id: Number(state_info?.id),
        }),
      );
    }
  }, [labDetail]);
};

export default useCreateObjEditLab;
